import {
  REACTION_LABEL_BASE_PX,
  REACTION_PREVIEW_FONT_FAMILY,
} from '../constants/previewTypography';

const H_PADDING_DESIGN_PX = 20;
const TRAILING_PAD_SINGLE_DESIGN_PX = 15;
const MIN_ARROW_WIDTH_DESIGN_PX = 48;

let measureCanvas: HTMLCanvasElement | null = null;

/**
 * Width needed for the reaction arrow column: wider label + horizontal padding,
 * matching preview span styles (font size, trailing padding for single-arrow).
 * Uses canvas.measureText once per render input — no layout thrash or useEffect.
 */
export function measureReactionArrowColumnWidth(
  topText: string,
  bottomText: string,
  schemeZoomScale: number,
  arrowType: 'single' | 'double'
): number {
  const fontPx = REACTION_LABEL_BASE_PX * schemeZoomScale;
  const font = `${fontPx}px ${REACTION_PREVIEW_FONT_FAMILY}`;

  const measureString = (s: string): number => {
    if (!s) return 0;
    if (typeof document === 'undefined') {
      return s.length * fontPx * 0.55;
    }
    if (!measureCanvas) measureCanvas = document.createElement('canvas');
    const ctx = measureCanvas.getContext('2d');
    if (!ctx) return s.length * fontPx * 0.55;
    ctx.font = font;
    return ctx.measureText(s).width;
  };

  const textW = Math.max(measureString(topText), measureString(bottomText));
  const hPad = H_PADDING_DESIGN_PX * schemeZoomScale;
  const trailing = arrowType === 'double' ? 0 : TRAILING_PAD_SINGLE_DESIGN_PX * schemeZoomScale;
  const minW = MIN_ARROW_WIDTH_DESIGN_PX * schemeZoomScale;

  return Math.round(Math.max(minW, textW + hPad + trailing) * 100) / 100;
}
